import { render, staticRenderFns } from "./PrepaymentAmortization.vue?vue&type=template&id=7cf4cf2a&"
import script from "./PrepaymentAmortization.vue?vue&type=script&lang=js&"
export * from "./PrepaymentAmortization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports